<template>
  <!-- 单元列表 -->
  <div
    v-if="unitList.length"
    :class="{
      'h5-lesson-list': isH5,
      'lesson-list-wrap': !isH5,
      'electron-lesson-list': isElectron,
    }"
  >
    <el-collapse v-model="activeNames">
      <el-collapse-item
        v-for="(unit, unitIndex) in unitList"
        :key="unit.id"
        :title="unit.unit_name"
        :name="unit.id"
      >
        <template slot="title">
          <div class="unit-name">
            {{ unit.unit_name }}
          </div>
        </template>
        <ul
          v-if="unit.lesson_list && unit.lesson_list.length"
          class="lesson-list"
        >
          <li
            v-for="(lesson, lessonIndex) in unit.lesson_list"
            :key="lesson.id"
          >
            <!-- 直播课 -->
            <div
              v-if="[2, 4].includes(lesson.lesson_type)"
              class="lesson-wrap"
              @click="handleLiveClick(lesson)"
              :class="{ 'show-lock': showLock(lesson) }"
            >
              <!-- 左 -->
              <div class="lesson-info-wrap">
                <p class="lesson-name-wrap">
                  <span class="lesson-index">{{ lessonIndex + 1 }}</span>
                  <span
                    v-if="lesson.roomStatus === 2"
                    class="lesson-type-tag living"
                  >
                    <img
                      src="../../../assets/images/product-details/live.gif"
                      alt=""
                  /></span>
                  <span
                    v-else
                    class="lesson-type-tag"
                    :class="{ 'live-tag': lesson.liveStatus != 1 }"
                    >{{
                      [1].includes(lesson.liveStatus) ? "视频" : "直播"
                    }}</span
                  >
                  <span class="lesson-name">{{ lesson.lesson_name }}</span>
                </p>
                <div class="lesson-item-bottom">
                  <span
                    class="room-status"
                    :class="lesson.roomStatus === 2 ? 'room-status-2' : ''"
                    >{{ lesson.roomStatusText }}</span
                  >
                  <span class="separate"></span>
                  <span class="duration">
                    {{
                      moment(lesson.live_start_time * 1000).format(
                        "YYYY.MM.DD HH:mm"
                      )
                    }}-{{
                      moment(lesson.live_end_time * 1000).format(
                        "YYYY.MM.DD HH:mm"
                      )
                    }}
                  </span>
                  <span class="separate"></span>
                  <el-tooltip
                    v-if="lesson.lesson_type === 4"
                    popper-class="moguo-tooltip"
                    class="item"
                    effect="dark"
                    :content="lesson.teachers"
                    placement="top"
                    :disabled="!lesson.isShowTooltip"
                  >
                    <p
                      class="teacher"
                      @mouseenter="
                        visibilityChange($event, lesson, unitIndex, lessonIndex)
                      "
                    >
                      {{ lesson.teachers }}
                    </p>
                  </el-tooltip>
                  <p v-else class="teacher">
                    {{ lesson.org_nickname }}
                  </p>
                </div>
              </div>
              <div class="lesson-right-wrap">
                <span v-if="lesson.canTrial && !isRegistered" class="trial-tag"
                  >试学</span
                >
                <div
                  v-else-if="isRegistered"
                  class="operation"
                  :class="{
                    'have-operation':
                      [1, 3].includes(lesson.liveStatus) || lesson.tips,
                    'show-trial': lesson.canTrial && !isRegistered,
                  }"
                >
                  <el-button
                    v-if="lesson.liveStatus === 1"
                    class="replay-btn"
                    size="small"
                    type="text"
                    >观看视频</el-button
                  >
                  <el-button
                    class="join-room-btn"
                    v-else-if="lesson.liveStatus === 3"
                    size="small"
                    type="text"
                    >进入教室</el-button
                  >
                  <span v-else class="tips-text">{{ lesson.tips }} </span>
                </div>
              </div>
            </div>
            <!-- 点播课 -->
            <div
              v-else-if="lesson.lesson_type === 1"
              @click="goReplay(lesson)"
              class="lesson-wrap"
              :class="{ 'show-lock': showLock(lesson) }"
            >
              <div class="lesson-info-wrap">
                <p class="lesson-name-wrap">
                  <span class="lesson-index">{{ lessonIndex + 1 }}</span>
                  <span class="lesson-type-tag saas-demand-color">视频</span>
                  <span class="lesson-name">{{ lesson.lesson_name }}</span>
                </p>
                <div class="lesson-item-bottom">
                  <span class="duration">
                    {{ handleDuration(lesson.duration) }}
                  </span>
                </div>
              </div>
              <div class="lesson-right-wrap">
                <span v-if="lesson.canTrial && !isRegistered" class="trial-tag"
                  >试学</span
                >
                <div
                  v-else
                  class="operation"
                  :class="{
                    'have-operation': lesson.canTrial || isRegistered,
                  }"
                >
                  <el-button
                    type="text"
                    v-if="lesson.canTrial || isRegistered"
                    class="replay-btn"
                  >
                    观看视频
                  </el-button>
                </div>
              </div>
            </div>
            <!-- 作业 -->
            <div
              v-else-if="lesson.lesson_type === 3"
              class="lesson-wrap"
              @click="goHomeWorkPage(lesson.work_info)"
              :class="{ 'show-lock': showLock(lesson) }"
            >
              <div class="lesson-info-wrap">
                <p class="lesson-name-wrap">
                  <span class="lesson-index">{{ lessonIndex + 1 }}</span>
                  <span class="lesson-type-tag saas-homework-color">作业</span>
                  <span class="lesson-name">{{
                    lesson.work_info.homework_name
                  }}</span>
                </p>
                <div class="lesson-item-bottom">
                  <span v-if="lesson.work_end_time" class="duration"
                    >限{{
                      moment(lesson.work_end_time * 1000).format("YYYY-MM-DD")
                    }}前完成</span
                  >
                  <span v-else class="duration">不限时</span>
                </div>
              </div>
              <div class="lesson-right-wrap"></div>
            </div>
          </li>
        </ul>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import LessonList from "./mixins/lesson-list.js";
export default {
  mixins: [LessonList],
  methods: {
    visibilityChange(event, lesson, unitIndex, lessonIndex) {
      if (lesson.isShowTooltip !== undefined) return;
      const ev = event.target;
      let ev_size = ev.scrollWidth;
      let content_size = ev.clientWidth;
      if (ev_size > content_size) {
        this.$set(
          this.unitList[unitIndex].lesson_list[lessonIndex],
          "isShowTooltip",
          true
        );
      } else {
        this.$set(
          this.unitList[unitIndex].lesson_list[lessonIndex],
          "isShowTooltip",
          false
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$lesson-index-width: 25px;
.lesson-list-wrap {
  .lesson-type-tag {
    display: inline-block;
    border-radius: 6px;
    border: 1px solid #efefef;
    font-weight: 400;
    font-size: 14px;
    color: #515350;
    line-height: 20px;
    height: 22px;
    padding: 0 6px;
    background: #fff;
    width: auto;
    &.living {
      width: 40px;
      border: 1px solid #b8e7dd;
      padding-top: 3px;
      padding-bottom: 3px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &.live-tag {
      border: 1px solid #b8e7dd;
      color: #00c89d;
    }
  }
  .el-collapse {
    border-top: none;
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__header {
    background: $saas-bg-color;
    border-radius: 12px;
    padding: 12px 20px 12px 16px;
    font-weight: 400;
    font-size: 16px;
    color: $saas-text-color;
    line-height: 22px;
    border: none;
    .unit-name {
      white-space: nowrap;
      line-break: anywhere;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 95%;
      flex: 1;
    }
    i {
      color: $plain-text-color;
      font-size: 12px;
      font-weight: 600;
    }
  }
  ::v-deep .el-collapse-item__content {
    padding: 0;
  }
  ::v-deep .el-collapse-item__wrap {
    border: none;
  }
  ::v-deep .el-collapse-item {
    margin-bottom: 16px;
  }
  .lesson-list > li {
    padding: 0 4px;
    &:hover {
      background: #f7f8fa;
    }
  }
  .lesson-wrap {
    position: relative;
    cursor: pointer;
    padding: 16px 20px 16px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #efefef;
    &.show-lock::after {
      position: absolute;
      content: " ";
      right: 0;
      // bottom: 28px;
      display: block;
      width: 20px;
      height: 20px;
      background: url("../../../assets/images/product-details/lock.png");
      background-size: 100% 100%;
      right: 20px;
    }
    .lesson-info-wrap {
      flex: 1;
    }
    .lesson-name-wrap {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .lesson-index {
        font-size: 16px;
        color: #858687;
        line-height: 22px;
        width: $lesson-index-width;
      }
      .lesson-name {
        flex: 1;
        width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 16px;
        color: $saas-text-color;
        line-height: 22px;
        margin-left: 8px;
      }
    }
    .lesson-item-bottom {
      display: flex;
      align-items: center;
      color: $plain-text-color;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      padding-left: 74px;
      .separate {
        width: 1px;
        height: 8px;
        background: #efefef;
        border-radius: 1px;
        margin: 0 10px;
      }
      .room-status-2 {
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        background: linear-gradient(
          41.94400710581127deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .teacher {
        flex: 1;
        width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .lesson-right-wrap {
      min-width: 135px;
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
    }
    .show-trial.operation {
      .el-button {
        font-size: 12px !important;
      }
      span {
        font-size: 12px !important;
      }
    }
    .replay-btn {
      font-weight: 400;
      font-size: 16px;
      color: $saas-text-color;
      line-height: 22px;
      padding: 0;
    }
    .join-room-btn {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      background: linear-gradient(
        41.94400710581127deg,
        $linear-gradient-begin 0%,
        $linear-gradient-end 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      padding: 0;
    }
    .trial-tag {
      width: 40px;
      height: 22px;
      border-radius: 6px;
      border: 1px solid #feadb7;
      font-size: 14px;
      color: #f03349;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      // font-weight: 500;
      // font-size: 16px;
      // line-height: 22px;
      // background: linear-gradient(
      //   41.94400710581127deg,
      //   $linear-gradient-begin 0%,
      //   $linear-gradient-end 100%
      // );
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
    .tips-text {
      font-weight: 400;
      font-size: 16px;
      color: $plain-text-color;
      line-height: 22px;
    }
    // .tips-text.tips-text-2 {
    //   font-weight: 400;
    //   font-size: 12px;
    //   color: $plain-text-color;
    //   line-height: 17px;
    // }
  }
  .lesson-list > li:last-child {
    .lesson-wrap {
      border-bottom: none;
    }
  }
}

.electron-lesson-list.lesson-list-wrap {
  .lesson-type-tag {
    font-size: 12px;
    line-height: 18px;
    height: 20px;
    padding: 0 6px;
    &.living {
      width: 38px;
      padding-top: 2px;
      padding-bottom: 2px;
    }
  }
  ::v-deep .el-collapse-item__header {
    height: 44px;
    padding: 10px 20px 10px 16px;
    font-size: 14px;
    line-height: 20px;
    i {
      font-size: 10px;
    }
  }
  ::v-deep .el-collapse-item {
    margin-bottom: 12px;
  }
  .lesson-list > li {
    padding: 0 8px;
  }
  .lesson-wrap {
    padding: 12px 0;
    .lesson-name-wrap {
      margin-bottom: 6px;
      .lesson-name {
        font-size: 14px;
        line-height: 20px;
        margin-left: 6px;
      }
    }
    .lesson-item-bottom {
      padding-left: 70px;
    }
    .replay-btn {
      font-size: 14px;
      line-height: 20px;
    }
    .join-room-btn {
      font-size: 14px;
      line-height: 20px;
    }
    .trial-tag {
      font-size: 14px;
      line-height: 20px;
      margin-right: 15px;
    }
    .tips-text {
      font-size: 14px;
      line-height: 20px;
    }
  }
}

// 适配
.h5-lesson-list {
  padding: 0 0.37rem 0 0.27rem;
  .lesson-type-tag {
    display: inline-block;
    height: 0.56rem;
    border-radius: 0.15rem;
    border: 0.03rem solid #efefef;
    font-weight: 400;
    font-size: 0.35rem;
    color: #515350;
    line-height: 0.5rem;
    padding: 0 0.16rem;
    background: #fff;
    width: auto;
  }
  .el-collapse {
    border-top: none;
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__header {
    background: $saas-bg-color;
    border-radius: 0.3rem;
    padding: 0.3rem 0.15rem 0.3rem 0.4rem;
    font-weight: 400;
    font-size: 0.41rem;
    line-height: 0.56rem;
    color: $saas-text-color;
    border: none;
    .unit-name {
      white-space: nowrap;
      line-break: anywhere;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 95%;
    }
    i {
      color: $plain-text-color;
      font-weight: 600;
      font-size: 0.27rem;
    }
  }
  ::v-deep .el-collapse-item__content {
    padding-bottom: 0;
  }
  ::v-deep .el-collapse-item__wrap {
    border: none;
  }
  ::v-deep .el-collapse-item {
    margin-bottom: 0.41rem;
  }
  .lesson-list > li {
    padding: 0 0.05rem;
  }
  .lesson-wrap {
    padding: 0.55rem 0 0.45rem 0.3rem;
    border-bottom: 0.03rem solid #efefef;
    .lesson-name-wrap {
      display: flex;
      align-items: center;
      margin-bottom: 0.2rem;
      .lesson-name {
        flex: 1;
        width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 400;
        font-size: 0.41rem;
        color: $saas-text-color;
        line-height: 0.56rem;
        margin-left: 0.21rem;
      }
    }
    .lesson-item-bottom {
      display: flex;
      align-items: center;
      color: $plain-text-color;
      font-weight: 400;
      font-size: 0.3rem;
      line-height: 0.43rem;
      .separate {
        width: 0.03rem;
        height: 0.2rem;
        background: #efefef;
        border-radius: 0.03rem;
        margin: 0 0.25rem;
      }
      .room-status-2 {
        font-weight: 400;
        font-size: 0.3rem;
        line-height: 0.43rem;
        background: linear-gradient(
          41.94400710581127deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .teacher {
        flex: 1;
        width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .trial-tag {
      font-weight: 500;
      font-size: 0.41rem;
      line-height: 0.56rem;
      background: linear-gradient(
        41.94400710581127deg,
        $linear-gradient-begin 0%,
        $linear-gradient-end 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .join-room-btn {
      font-weight: 500;
      font-size: 0.41rem;
      line-height: 0.56rem;
      background: linear-gradient(
        41.94400710581127deg,
        $linear-gradient-begin 0%,
        $linear-gradient-end 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .replay-btn {
      font-weight: 400;
      font-size: 0.41rem;
      color: $saas-text-color;
      line-height: 0.56rem;
      padding: 0;
    }
    .lesson-right-wrap {
      margin-top: 0.23rem;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: flex-end;
      .have-operation {
        margin-right: 0.27rem;
      }
    }
  }
  .lesson-list > li:last-child {
    .lesson-wrap {
      border-bottom: none;
    }
  }
}
::v-deep .el-collapse-item__arrow.el-icon-arrow-right.is-active {
  transform: rotate(-90deg);
}
::v-deep .el-collapse-item__arrow.el-icon-arrow-right {
  transform: rotate(90deg);
}
</style>
